import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Reorder from '../Reorder';

// import { basicMsg, confirmDialog } from '../../../../actions/swal_msg';
import { orderSelected, removeOrderFromList } from '../../../../actions/user-account';

import {
    Button, CardActions, Stack, useMediaQuery
} from '@mui/material';

const CardButtons = ({ order_num, products }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const matches = useMediaQuery('(max-width: 950px)');

    const { inactive_orders } = useSelector(state => state.user_account);

    const orderTracking = () => {
        const filter = inactive_orders.find(e => e.order_num === order_num);
        if (filter)
            navigate(`/rastrear-pedido/${filter.payment.nefro_reference}`, { state: filter });
    };

    const orderDetails = () => {
        const filter = inactive_orders.find(e => e.order_num === order_num);
        if (filter) {
            dispatch(orderSelected({ ...filter }));
            navigate('/mi-cuenta/detalles-pedido');
        }
    };

    // ocultar pedido en lista de pedidos abandonados
    // const hideOrder = async () => {
    //     if (await confirmDialog(
    //         '¿Ocultar el pedido?',
    //         '<p>Este pedido no se mostrará más en tus lista de pedidos abandonados, ¿deseas proceder?</p>',
    //         'Sí, ocultar'
    //     )) {
    //         const OrderFound = inactive_orders.find(e => e.order_num === order_num);
    //         if (OrderFound) {
    //             setHiddenOrder(OrderFound);
    //             dispatch(removeOrderFromList(order_num));
    //         } else basicMsg('No se recuperó el pedido');
    //     }
    // };

    return (
        <CardActions>
            <Stack spacing={1} direction= { matches ? "column" : "row" }
                sx={{ width: '100%', justifyContent: matches ? "center" : "flex-start" }}>
                <Button
                    onClick={ orderTracking }
                    sx={{ textTransform: 'none' }}
                >
                    Rastrear pedido
                </Button>
                <Button
                    onClick={ orderDetails }
                    sx={{ textTransform: 'none' }}
                >
                    Ver detalles
                </Button>
                {/* <Button
                    variant="outlined" color="error"
                    onClick={ hideOrder }
                    sx={{ textTransform: 'none' }}
                >
                    Ocultar pedido
                </Button> */}
                <Reorder
                    products={ products }
                    buttonData={{
                        full_width: false,
                        variant: 'outlined',
                        color: 'primary'
                    }}
                />
            </Stack>
        </CardActions>
    );
};

export default CardButtons;
